import React from "react";
import { useActiveBar } from "../ActiveBarContext";
import { auth } from "../../firebase";
import TodaysSpecialPoster from "../shared/TodaysSpecialPoster.jsx";

// Owner version of the "today's food special" photo post. Same poster as
// the staff page, but uses the owner's login instead of a staff code.
export default function TodaysSpecial() {
  const { myBars, activeBarId, setActiveBarId, activeBar } = useActiveBar();

  return (
    <div style={{ maxWidth: "560px", padding: "10px 0 40px" }}>
      {myBars.length > 1 && (
        <div style={{ marginBottom: "18px" }}>
          <label style={{ display: "block", fontSize: "16px", color: "#fff", marginBottom: "6px" }}>Bar</label>
          <select
            value={activeBarId}
            onChange={(e) => setActiveBarId(e.target.value)}
            style={{
              width: "100%", padding: "12px", fontSize: "16px", borderRadius: "8px",
              background: "#16121F", color: "#fff", border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            {myBars.map((b) => (
              <option key={b.id} value={b.id}>{b.name || "Unnamed Bar"}</option>
            ))}
          </select>
        </div>
      )}

      {myBars.length === 0 ? (
        <p style={{ color: "#B8B0C8", fontSize: "16px" }}>Claim your bar first, then you can post today's special here.</p>
      ) : (
        <TodaysSpecialPoster
          disabled={!activeBar}
          getAuthBody={async () => ({ barId: activeBar?.id })}
          getAuthHeaders={async () => {
            const token = await auth.currentUser?.getIdToken();
            return token ? { Authorization: `Bearer ${token}` } : {};
          }}
        />
      )}

      <p style={{ color: "#B8B0C8", fontSize: "15px", marginTop: "18px" }}>
        Want your bartender or cook to post this instead? Give them the staff code from your Bar Profile
        page and have them open <strong>portal.barfunfinder.com/staff-post</strong> on their phone.
      </p>
    </div>
  );
}
